import API from 'services/TAPS_API';

export default function getThemes(categoryCode) {
  return API.request({
    method: 'GET',
    url: `/dictionary/theme?category=${categoryCode}`,
  });
}
